"use client";

import React, {useEffect, useRef} from "react";

interface HeroVideoProps {
    src: string;
    poster?: string;
}

export default function HeroVideo({src, poster}: HeroVideoProps) {
    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        const videoEl = videoRef.current;
        if (!videoEl) return;
        // A pause() before play() resolves rejects with AbortError; swallow it.
        videoEl.play().catch(() => {});
    }, []);

    return (
        <video
            ref={videoRef}
            className="shadow-xl rounded-xl mt-4 w-full"
            src={src}
            poster={poster}
            preload="auto"
            playsInline
            muted
            loop
            controls
        />
    );
}
